require('./').polyfill()



//////////////////
// WEBPACK FOOTER
// ./node_modules/raf/polyfill.js
// module id = 682
// module chunks = 58